import Marquee from "react-fast-marquee";

const BASE =
  "https://customer-assets-jt897jd0.emergentagent.net/job_design-franco/artifacts";

// One continuous strip. Kept in project order: LOVER, then The Cleanse, then Web.
const IMAGES = [
  { name: "LOVER — Lubricant", file: "p10h19mz_Screenshot%202026-08-18%20at%207.17.24%E2%80%AFPM.png" },
  { name: "LOVER — Packaging", file: "60hf282f_Screenshot%202026-08-18%20at%207.16.57%E2%80%AFPM.png" },
  { name: "LOVER — Art Direction", file: "exq00fd2_Screenshot%202026-08-18%20at%207.25.26%E2%80%AFPM.png" },
  { name: "COS — Cold Press", file: "eaz3v86b_Screenshot%202026-08-18%20at%207.18.01%E2%80%AFPM.png" },
  { name: "The Cleanse — Campaign", file: "gh8gexsi_Screenshot%202026-08-18%20at%207.19.43%E2%80%AFPM.png" },
  { name: "The Cleanse — Launch", file: "6hchbk5u_Screenshot%202026-08-18%20at%207.23.41%E2%80%AFPM.png" },
  { name: "RADIATE — Landing", file: "01rvf386_Screenshot%202026-08-18%20at%207.31.57%E2%80%AFPM.webp" },
  { name: "RADIATE — Player", file: "pl366pm3_Screenshot%202026-08-18%20at%207.35.21%E2%80%AFPM.png" },
  { name: "Greenwich Village Baths — Site", file: "scp0db3g_Screenshot%202026-08-18%20at%207.33.55%E2%80%AFPM.webp" },
  { name: "GVB — Passes", file: "o095aasu_Screenshot%202026-08-18%20at%207.33.35%E2%80%AFPM.webp" },
  { name: "GVB — Visit", file: "yg2mwhol_Screenshot%202026-08-18%20at%207.32.08%E2%80%AFPM.webp" },
];

const Tile = ({ im, i }) => (
  <div className="flex h-[260px] md:h-[360px] items-center px-2 md:px-4 shrink-0">
    <a
      href="#contact"
      data-testid={`work-project-${i + 1}`}
      aria-label={im.name}
      className="relative block h-[220px] md:h-[320px]"
    >
      <img
        src={`${BASE}/${im.file}`}
        alt={im.name}
        loading="lazy"
        className="block h-full w-auto max-w-none"
      />
    </a>
  </div>
);

const SelectedWork = () => {
  return (
    <section
      id="work"
      data-testid="work-section"
      className="relative overflow-hidden bg-[#f7f3ea] py-20 md:py-32"
    >
      <div className="px-6 md:px-12 lg:px-16 mb-10 md:mb-16">
        <span className="label text-[#0a0a0a]/40">(Portfolio)</span>
      </div>

      <Marquee speed={38} gradient={false} autoFill>
        {IMAGES.map((im, i) => (
          <Tile key={im.name} im={im} i={i} />
        ))}
      </Marquee>
    </section>
  );
};

export default SelectedWork;
